var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#DEDEDE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1632_5596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 10.0194C12.6862 10.0194 12.5 10.2061 12.5 10.436V13.7694C12.5 13.999 12.3133 14.186 12.0834 14.186H6.25C6.01997 14.186 5.83336 13.999 5.83336 13.7694V7.93604C5.83336 7.70647 6.01997 7.51939 6.25 7.51939H9.58336C9.81377 7.51939 10 7.3327 10 7.10275C10 6.87273 9.81377 6.68604 9.58336 6.68604H6.25C5.56084 6.68604 5 7.24687 5 7.93604V13.7694C5 14.4586 5.56084 15.0194 6.25 15.0194H12.0834C12.7725 15.0194 13.3334 14.4586 13.3334 13.7694V10.436C13.3334 10.2056 13.147 10.0194 12.9166 10.0194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90672 9.63943C8.87758 9.66858 8.85797 9.70566 8.84965 9.74564L8.55508 11.219C8.54135 11.2873 8.56302 11.3577 8.61215 11.4073C8.65175 11.4469 8.70507 11.4681 8.7597 11.4681C8.77298 11.4681 8.78679 11.4669 8.80052 11.464L10.2734 11.1694C10.3143 11.161 10.3513 11.1415 10.3801 11.1123L13.6768 7.81563L12.2038 6.34277L8.90672 9.63943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6951 5.32423C14.2889 4.91796 13.628 4.91796 13.2221 5.32423L12.6455 5.90086L14.1184 7.37379L14.6951 6.79708C14.8918 6.60086 15.0001 6.33917 15.0001 6.06085C15.0001 5.78253 14.8918 5.52084 14.6951 5.32423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1632_5596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/editSvg.acc5c1f6996c6819248100c242c5378f.svg";
export { ForwardRef as ReactComponent };